//CALENDER
export const GET_EVENTS = "/events";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";
export const GET_CATEGORIES = "/categories";

//PRODUCTS
export const GET_PRODUCTS = "/products";
export const GET_PRODUCTS_DETAIL = "/product";

//SHOPS
export const GET_SHOPS = "/shops";

//ORDERS
export const GET_ORDERS = "/orders";

//CART DATA
export const GET_CART_DATA = "/cart";
export const ADD_NEW_ORDER = "/add/order";

//CUSTOMERS
export const GET_CUSTOMERS = "/customers";

//CHATS
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "/add/messages";

//CUSTOMER
export const CUSTOMER_LIST = "/customer/list";
export const CUSTOMER_CREATE = "/customer/create";
export const CUSTOMER_UPDATE = (ul_id) => `/customer/${ul_id}`;
export const DELETE_CUSTOMER = (ul_id) => `/customer/${ul_id}`;

//staff
export const EMPLOYEE_LIST = "/employee/list";
export const EMPLOYEE_CREATE = "/employee/create";
export const UPDATE_EMPLOYEE = (ul_id) => `/employee/${ul_id}`;
export const DELETE_EMPLOYEE = (ul_id) => `/employee/${ul_id}`;
export const USER_LIST = "/admin/list";
export const USER_CREATE = "/admin/create";
export const USER_UPDATE = (ul_id) => `/admin/${ul_id}`;
export const DELETE_USER = (ul_id) => `/admin/${ul_id}`;
export const USER_PROFILE = `/profile`;
export const RESET_PASSWORD = `/reset-password`;

// Transaction
// Transaction
export const TRANSACTION_LIST = "/transaction/list";
export const TRANSACTION_CREATE = "/transaction/create";
export const DELETE_TRANSACTION = (ul_id) => `/transaction/${ul_id}`;
export const UPDATE_TRANSACTION = (ul_id) => `/transaction/${ul_id}`;

// nozzle
export const NOZZLE_LIST = "/nozzel/list";
export const NOZZLE_CREATE = "/nozzel/create";
export const UPDATE_NOZZLE = (ul_id) => `/nozzel/${ul_id}`;
export const DELETE_NOZZLE = (ul_id) => `/nozzel/${ul_id}`;
export const UPDATE_NOZZLE_STOCK = (ul_id) => `/nozzel/update_stock/${ul_id}`;
export const GET_ASSIGNED_NOZZEL = "/nozzel/get_assigned_nozzel";
export const ASSIGN_NOZZEL = (ul_id) => `/assign_nozzel/${ul_id}`;
export const UNASSIGN_NOZZEL = (ul_id) => `/unassign_nozzel/${ul_id}`;

// Price List
export const PRICE_LIST = "/product/list";
export const PRICE_CREATE = "/product/create";
export const UPDATE_PRICE = (ul_id) => `/product/${ul_id}`;
export const DELETE_PRICE = (ul_id) => `/product/${ul_id}`;

export const TICKET_LIST = "/ticket/list";
export const UPDATE_TICKET = (ul_id) => `/ticket/${ul_id}`;
export const GET_TICKET_BY_ID = (id) => `/ticket/${id}`;

export const DELETE_ORDER = (ul_id) => `/order/${ul_id}`;

//Dahashboard
export const DASHBOARD = "/dashboard/list";
export const REPORTS = "/invoice/list";

export const INVOICE_LIST = "/invoice/list";
export const INVOICE_CREATE = "/invoice/create";
export const INVOICE_ID = "/invoice/get-latest-invoice";
export const GET_INVOICE_BY_ID = (ul_id) => `/invoice/${ul_id}`;
export const INVOICE_UPDATE = (ul_id) => `/invoice/${ul_id}`;
export const DELETE_TICKET = (ul_id) => `/invoice/${ul_id}`;

export const SEND_EMAIL = 'invoice/send-email';
export const GET_ACCOUNTANT_HISTORY = "/general/accountant_history";
export const GET_HISTORY = "/general/history";

export const getApiUrl = (endpoint) => {
  const baseUrl = process.env.REACT_APP_API_URL || 'https://sabji-api.namashkarfuel.com/api';
  return `${baseUrl}/${endpoint}`;
};

export const getAuthUrl = (endpoint) => {
  const baseUrl = process.env.REACT_APP_AUTH_URL || 'https://sabji-api.namashkarfuel.com/auth';
  return `${baseUrl}/${endpoint}`;
};